import axios from 'axios'
import Company from './Company.class'
import {get} from 'lodash'
import moment from 'moment'
const baseURL = '/api/employment/'

export default class Employment {
	/** @constructor
	 * @param {number | Object} init
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		// this.company = init.hasOwnProperty('company') ? init.company : ''
		// this.company_id = init.hasOwnProperty('company_id') ? init.company_id : ''
		this.company = new Company({
			id: init.company_id,
			name: init.company
		})
		this.position = get(init, 'position') ? init.position : ''
		this.description = get(init, 'description') ? init.description : ''
		this.start_year = get(init, 'start_year') ? String(init.start_year) : null
		this.start_month = get(init, 'start_month') ? String(init.start_month) : null
		this.end_year = get(init, 'end_year') ? String(init.end_year) : null
		this.end_month = get(init, 'end_month') ? String(init.end_month) : null

		// not request
		this.isCreate = get(init, 'isCreate') ? init.isCreate : false
	}

	static url = baseURL

	/**
	 * get all news
	 * @param {Object} params
	 * @returns {Promise<{data: News[]}>}
	 */
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: res.data.data.map(item => new Employment(item))
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	/**
	 * get news by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}

	get dateIsCorrect () {
		if (!(this.start_year || this.start_month || this.end_year || this.end_month)) return true

		let startStr = this.start_year
		if (!this.start_year) return false

		let startDate = null
		if (this.start_month) {
			startStr = startStr + '-' + this.start_month
			startDate = moment(startStr, 'YYYY-MM')
		} else {
			startDate = moment(startStr, 'YYYY')
		}

		let endDate = null
		if (this.end_year) {
			let endStr = this.end_year
			if (this.end_month) {
				endStr = endStr + '-' + this.end_month
				endDate = moment(endStr, 'YYYY-MM')
			} else {
				endDate = moment(endStr, 'YYYY')
			}
		}

		if (startDate.isValid()) {
			if (endDate && endDate.isValid()) {
				if (endDate.diff(startDate) >= 0) {
					return true
				} else {
					return false
				}
			}

			return true
		} else {
			return false
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Employment.class.js